// extracted by mini-css-extract-plugin
export var resizer = "_by-0";